import { Component } from '@angular/core'

@Component({
  selector: 'se-po-affiliation-access-docs',
  templateUrl: './affiliation-access-docs.component.html',
  styleUrls: ['./affiliation-access-docs.component.scss'],
  standalone: false,
})
export class AffiliationAccessDocsComponent {}
